import {RowType} from 'common/query-builder/query-entry-section/row-types/types';
import {MetricEntry} from 'common/query-builder/query-entry-section/types';
import {MetricType} from 'common/query-builder/query-block/constants';
import {RetentionAlignmentType, RetentionType} from 'common/report/retention/util/types';
import {TimeUnit} from 'common/widgets/date-range-picker/models/types';
import {RestrictEntitySaving, RETENTION_MATH_TYPES} from 'common/report/constants';
import {getAllSavedBehaviors} from 'common/query-builder/query-entry-section/row-types/metric-entry/metrics/behavior-utils';
import {BehaviorsResource} from 'common/report/model-resources/behaviors';
import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';

export function hasSavedRetentionBehaviors({behaviors}: {behaviors: BehaviorsResource}): boolean {
  const savedBehaviors = getAllSavedBehaviors({behaviors, metricType: MetricType.Retention});
  return savedBehaviors.length > 0;
}

export function canSaveForPlan(currentProject: CurrentProject): boolean {
  return Boolean(currentProject?.canSaveEntity(RestrictEntitySaving.BehaviorMetrics));
}

export function getNewEntry({isExpanded, type}: {isExpanded: boolean; type: RowType}): MetricEntry {
  return type === MetricType.Retention
    ? {
        type: `metric-entry`,
        behavior: {
          type: MetricType.Retention,
          name: null,
          retentionType: `birth` as RetentionType,
          retentionAlignmentType: RetentionAlignmentType.Birth,
          retentionUnit: TimeUnit.Day,
          retentionUnboundedMode: `none`,
          retentionCustomBucketSizes: [],
          behaviors: [
            {
              type: MetricType.Event,
              name: null,
              filters: [],
            },
            {
              type: MetricType.Event,
              name: null,
              filters: [],
            },
          ],
        },
        measurement: {
          aggregationOperator: RETENTION_MATH_TYPES.RETENTION_RATE,
          retentionBuckets: [],
          retentionBucketIndex: 0,
        },
        isExpanded,
      }
    : {
        type: `metric-entry`,
        behavior: {
          type: MetricType.RetentionFrequency,
          name: null,
          retentionType: `addiction`,
          retentionAlignmentType: RetentionAlignmentType.Birth,
          retentionUnit: TimeUnit.Day, // TODO
          retentionUnboundedMode: `none`,
          behaviors: [
            {
              type: MetricType.Event,
              name: null,
              filters: [],
            },
          ],
        },
        measurement: {
          aggregationOperator: RETENTION_MATH_TYPES.RETENTION_RATE,
          retentionBuckets: [],
          retentionBucketIndex: 0,
        },
        isExpanded,
      };
}
